import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  logo = environment.logo;


  siteUrl = environment.siteUrl;

  currentHome: any;
  linksRS: any;

  constructor(private apiService: ApiService) {}

  ngOnInit() {
    this.currentHome = this.apiService.currentHome;
    if (this.currentHome) {
      this.processHomeInfos();
    }
    this.apiService.currentHomeChanges.subscribe((currentHome) => {
      this.currentHome = currentHome;
      this.processHomeInfos();
    });
  }

  processHomeInfos() {
    this.linksRS = {
      facebook: this.currentHome.facebook,
      twitter: this.currentHome.twitter,
      linkedin: this.currentHome.linkedin,
      instagram: this.currentHome.instagram,
    };
  }
}
